import { createContext, useContext, useState } from "react";

const LoadScenarioContext = createContext();

export const LoadScenarioProvider = ({ children }) => {
  const [key, setKey] = useState(0);

  const refreshFlow = () => {
    setKey((prev) => prev + 1);
  };

  return (
    <LoadScenarioContext.Provider value={{ key, refreshFlow }}>
      {children}
    </LoadScenarioContext.Provider>
  );
};

export const useLoadScenario = () => {
  const context = useContext(LoadScenarioContext);
  if (!context) {
    throw new Error(
      "useLoadScenario must be used within a LoadScenarioProvider",
    );
  }
  return context;
};
